import React, { useState } from 'react';
import '../styles/Login.css';
import logo from '../assets/logo.jpg';

const Login = ({ onLogin }: { onLogin: () => void }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (username === 'admin' && password === 'admin') {
      localStorage.setItem('token', 'demo-token');
      onLogin();
    } else {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="finapp-login-bg">
      {/* Top header bar with logo and company name */}
      <div className="finapp-login-headerbar">
        <img src={logo} alt="Keshava Prabha Logo" className="finapp-login-headerlogo" />
        <div className="finapp-login-headertext">
          {/* <div className="finapp-login-header-title">Keshava Prabha</div>
          <div className="finapp-login-header-sub">Microfin Pvt Ltd</div> */}
        </div>
      </div>
      {/* Background overlay and center content */}
      <div className="finapp-login-main">
        <div className="finapp-login-overlay" />
        <div className="finapp-login-content">
          <div className="finapp-login-left">
            <div className="finapp-login-app-title">
              <span>Keshava Prabha<br />Microfin</span>
              <div className="finapp-login-app-sub">Insight</div>
            </div>
          </div>
          <div className="finapp-login-box">
            <form className="finapp-login-form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className="finapp-login-input"
                autoFocus
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="finapp-login-input"
              />
              {error && <div className="finapp-login-error">{error}</div>}
              <button type="submit" className="finapp-login-btn">LOGIN</button>
            </form>
          </div>
        </div>
      </div>
      <div className="finapp-login-footer">
        <div className="finapp-login-copyright">
          Copyright © 2018 Keshava Prabha Microfin Ltd.
        </div>
      </div>
    </div>
  );
};

export default Login;
